const quoteList = {
  title: 'عروض الأسعار المستلمة',
  select: 'اختر',
  discountOff: 'خصم',
  coverage: 'التغطية',
  features: 'المزايا',
  policyLimit: 'حدود تغطية التأمين',
  deductible: 'نسبة/قيمة التحمل',
  retroactiveCover: 'التغطية بأثر رجعي',
  extendedReportingPeriod: 'فترة التبليغ الممتدة',
  noPolicyLimits: 'لا توجد حدود تغطية التأمين',
  noDeductibles: 'لا توجد قيمة تحمل',
  noRetroactiveCover: 'لا توجد خيارات للتغطية بأثر رجعي',
  noCompulsoryRetroactiveCover:
    'مجاناً! تأمين بأثر رجعي إلزامى , يبدأ من {{retroactiveStartDate}} حتى تاريخ بداية الوثيقة المطلوب إصدارها',
  noExtendedReportingPeriod: 'لا توجد خيارات لتمديد مدة التبليغ',
  forMoreDetails: 'لمزيد من التفاصيل، يرجى مراجعة',
  termsAndConditions: 'الشروط والأحكام',
  discountApplied: 'تم تطبيق الخصم',
  totalDiscount: 'إجمالي الخصم',
  applied: 'مطبق',
  selectQuotation: 'اختر العرض',
  continueToPay: 'المتابعة للدفع',
  selectionSuccess: 'تم اختيار العرض بنجاح',
  selectionError: 'فشل في اختيار العرض',
  bestValue: 'أفضل قيمة',
  policyDuration: 'فترة التأمين',
  policyLimitLabel:
    'حد المطالبة الواحدة {{oneTimeOccurrence}} ر.س و الحد الأقصى السنوي {{aggregateOccurrence}} ر.س',
  onYears: 'على {{years}} سنوات',
  benefitsDescription:
    'المزايا التي ستحصل عليها {{years}} سنين مدة للوثيقة او اكثر.',
  benefitsHeaderContent:
    'إختار {{years}} سنوات أو أكثر للحصول على {{benefits}}',
  policyHolderDetails: 'تفاصيل حامل الوثيقة',
  policyHolderId: 'هوية حامل الوثيقة:',
  specialty: 'التخصص الطبي:',
  benefitsDesc:
    'تأميني ينصح بإختيار فترات أطول لوثيقة التأمين للتمتع بمزايا متعددة',
  seeBenefits: 'عرض المزايا',
  priceStability: 'قيمة أفضل بسعر أقل',
  continuityOfCoverage: 'إستمرارية التغطية لفترة أطول',
  discountsOnOtherProducts: 'خصومات على منتجات تأميني الأخرى',
  noAnnualRenewalNeeded: 'عدم الحاجة لتجديد الوثيقة سنوياً',
  resetFilters: 'إزالة الفلاتر',
  applyFilters: 'تطبيق الفلاتر',
  filterAndSort: 'فلترة وترتيب',
  sortBy: 'ترتيب حسب',
  priceLowToHigh: ' ترتيب بالأقل سعراً',
  priceHighToLow: 'ترتيب بالأعلى سعراً',
  insuranceCompanies: 'شركات التأمين',
  tamaraHintDescription: 'قسم المبلغ المطلوب الى اقساط متساوية مع تمارا',
  tabbyHintDescription: 'قسم المبلغ المطلوب الى اقساط متساوية مع تابي',
  upgradeYourPolicy: 'ترقية وثيقتك',
  exclusiveDeal: 'عرض حصري',
  upgradePolicyTitle: 'اختر مدة وثيقة أطول للتمتع بمزايا أكثر',
  totalPrice: 'السعر الإجمالي:',
  policyFeatures: 'مميزات الوثيقة',
  termsApplied: 'الشروط والأحكام مطبقة',
  skip: 'تكملة بتغطية سنة واحدة فقط',
  proceedWithOffer: 'شراء العرض المُختار',
  benefits: 'المزايا',
  benefitsAddedToPolicy:
    '{{count}} مزايا تمت إضافتها بنجاح لوثيقتك! المزيد من المزايا متوفرة لفترات أطول...',
  specialtyDiscount: {
    popupTitle: 'خصم خاص لممارسي {{specialtyName}}',
    popupBody:
      'احصل على خصم {{percent}}% على تأمين الأخطاء الطبية. استخدم الرمز أدناه عند الدفع. العرض ساري حتى {{endDate}}.',
    copyCode: 'نسخ الرمز',
    copied: 'تم النسخ!',
    viewQuotes: 'عرض الأسعار',
    label:
      'خصم {{percent}}% لممارسي {{specialtyName}}. استخدم الرمز <voucher>{{voucherCode}}</voucher> عند الدفع.',
    copy: 'نسخ',
    copyFailed: 'تعذّر النسخ. يرجى نسخ الرمز يدويًا: {{voucherCode}}',
  },
} as const

export default quoteList
